export default {
  body: 'Titillium Web, sans-serif',
  headings: 'Titillium Web, sans-serif'
}
